import React,{useState,useEffect,useRef}from 'react'
import { Modal,Form,Input, App} from 'antd';
import { useBumenUpdateSaveMutation } from '../../store/DianShangYeWuApi';  
function DeptEdit(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        // console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        d_name:props.d_name,
        d_qy_id:props.qy_id,
        d_qy_name:props.qy_name,
        d_cid:props.yh_id,
        d_cname:props.yh_name,
        d_id:props.d_id,
        d_update_uname:props.yh_name,
    }); 
    const editForm = useRef()
    useEffect(() => {
        if(editForm.current){   
            editForm.current.setFieldsValue({
                d_name:props.d_name,
            })   
        }
    },[open ,props.d_name])
    const [deptEdit] = useBumenUpdateSaveMutation()    
    return (
        <>
            <a  onClick={() => {setOpen(true)}}>{props.d_name}</a>
            <Modal                       
                open={open}
                title='修改部门'
                okText="保存"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {                    
                    form
                        .validateFields()
                        .then((values) => {
                            deptEdit(info).then((res) => {
                                // console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('修改成功')   
                                    setOpen(false);
                                    form.resetFields();
                                    onCreateEdit(values);
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('修改失败：'+res.data.Message)
                                }
                            })
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_dept_edit_${props.yh_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 6 }}
                    ref={editForm}
                >                    
                    <Form.Item name="d_name" wrapperCol={{span:14}} required label='部门名称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,d_name:e.target.value}))
                        }}/>
                    </Form.Item>                                              
                    <Form.Item wrapperCol={{span:14}} label='新增记录'>                        
                        {props.d_ctime} {props.d_cname}
                    </Form.Item>
                    <Form.Item wrapperCol={{span:14}} label='修改记录'>                        
                        {props.d_update_time} {props.d_update_uname}
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default DeptEdit